import React from "react";
import "./StatusIndicator.css";

const StatusIndicator = ({ text = "Updating your Deal", indicator_type= "" }) => {
  return (
    <div className="status-indicator-wrapper">
      <div className={`${indicator_type == 'voice' ? 'glow-voice' : 'glow-dot' }`} ></div>
      <span className="status-text">{text}</span>
    </div>
  );
};

export default StatusIndicator;
